import './LandingPage.css';

import type { FC } from 'react';
import React, { useEffect } from 'react';

import { CustomAppsSection } from '@vse/views/application_landing_page/CustomAppsSection';
import { ApplicationTypes } from '@vse/machinelogic/constants/ApplicationTypes';
import { applicationUpload } from '@vse/legacy/uploadApplication';
import type { Library } from '@vse/machinelogic/types';
import { observer } from 'mobx-react-lite';

interface LandingPageProps {
  library: Library
  onApplicationSelected: () => void
}

export const LandingPage: FC<LandingPageProps> = observer(({ library, onApplicationSelected }) => {
  function openMachineLogicApp (): void {
    const app = library.getMachineLogicAppList().length > 0 ? library.getMachineLogicAppList()[0] : library.newApplication(ApplicationTypes.MachineLogic);
    library.selectApplication(app);
  }

  function openPythonApp (): void {
    const app = library.getPythonAppList().length > 0 ? library.getPythonAppList()[0] : library.newApplication(ApplicationTypes.Python);
    library.selectApplication(app);
  }

  useEffect(() => {
    if (library.currentApplication === undefined) {
      return;
    }

    onApplicationSelected();
  }, [library.currentApplication]);

  return (
    <div className='edge_application_landing_page machine_logic_page'>
      <h2>Get Started</h2>
      <CustomAppsSection library={library} openMachineLogicAppEditor={openMachineLogicApp} openPythonAppEditor={openPythonApp}/>
      <button className='edge_application_upload_button' onClick={() => { applicationUpload(library, (app) => { library.selectApplication(app); }); } }>
        <i className='icon-arrow-up'/>
        <span>Upload App</span>
      </button>
    </div>
  );
});
